import useSWRImmutable from 'swr/immutable';
import { getCustomerFromToken } from '@raisin/cp-utils';
import { getPostboxUnreadCount } from '../api/postbox';
import { Urls } from '../api/urls';
export const usePostboxUnreadCount = () => {
    // TODO temporarily disable this feature until we got a feedback from the design team!
    const shouldShowUnreadMessageFlag = false;
    const customer = getCustomerFromToken();
    const key = shouldShowUnreadMessageFlag && (customer === null || customer === void 0 ? void 0 : customer.bacNumber)
        ? Urls.PostboxUnreadThreadsCount(customer.bacNumber)
        : null;
    const fetcher = () => { var _a; return getPostboxUnreadCount((_a = customer === null || customer === void 0 ? void 0 : customer.bacNumber) !== null && _a !== void 0 ? _a : ''); };
    const { data, error } = useSWRImmutable(key, fetcher);
    return { data, error, loading: !(data || error) };
};
//# sourceMappingURL=usePostboxUnreadCount.js.map